function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary{fill:none;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("rect", {
  className: "highlights",
  x: 31.19,
  y: 182.17,
  width: 63.93,
  height: 49.83,
  rx: 12,
  transform: "translate(126.31 414.17) rotate(180)"
}), React.createElement("rect", {
  className: "highlights",
  x: 159.9,
  y: 182.17,
  width: 63.93,
  height: 49.83,
  rx: 12,
  transform: "translate(383.72 414.17) rotate(180)"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("rect", {
  className: "primary",
  x: 32,
  y: 160.07,
  width: 63.93,
  height: 63.93,
  rx: 12,
  transform: "translate(127.93 384.07) rotate(180)"
}), React.createElement("rect", {
  className: "primary",
  x: 159.37,
  y: 159.37,
  width: 64.63,
  height: 64.63,
  rx: 12,
  transform: "translate(383.37 383.37) rotate(180)"
}), React.createElement("path", {
  className: "primary",
  d: "M63.15,116c0-46.39,29.85-84,66.67-84s66.66,37.61,66.66,84"
}), React.createElement("line", {
  className: "primary",
  x1: 194.94,
  y1: 122.37,
  x2: 221,
  y2: 104.78
}), React.createElement("line", {
  className: "primary",
  x1: 169.54,
  y1: 102.07,
  x2: 194.55,
  y2: 122.22
}), React.createElement("line", {
  className: "primary",
  x1: 194.94,
  y1: 122.37,
  x2: 221,
  y2: 104.78
}), React.createElement("line", {
  className: "primary",
  x1: 169.54,
  y1: 102.07,
  x2: 194.55,
  y2: 122.22
})));
var SvgMoveStage = function SvgMoveStage(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoveStage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MoveStage.788cb887.svg";
export { ForwardRef as ReactComponent };